module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-info basic-info-detail",
    class: {
      'item-error': _vm.isError
    },
    on: {
      "touchend": _vm.tipClick
    }
  }, [_c('a', {
    staticClass: "placeholder",
    class: {
      'input-tip': _vm.showTip, 'error': _vm.isError
    }
  }, [_vm._v(_vm._s(_vm.tipText))]), _vm._v(" "), ((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusing),
      expression: "focusing"
    }],
    ref: "myinput",
    staticClass: "my-input",
    class: {
      'input-show': _vm.showTip
    },
    attrs: {
      "id": _vm.inputId,
      "maxlength": _vm.maxLength,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.content) ? _vm._i(_vm.content, null) > -1 : (_vm.content)
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": _vm.focusEvent,
      "change": function($event) {
        var $$a = _vm.content,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.content = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.content = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.content = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusing),
      expression: "focusing"
    }],
    ref: "myinput",
    staticClass: "my-input",
    class: {
      'input-show': _vm.showTip
    },
    attrs: {
      "id": _vm.inputId,
      "maxlength": _vm.maxLength,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.content, null)
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": _vm.focusEvent,
      "change": function($event) {
        _vm.content = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusing),
      expression: "focusing"
    }],
    ref: "myinput",
    staticClass: "my-input",
    class: {
      'input-show': _vm.showTip
    },
    attrs: {
      "id": _vm.inputId,
      "maxlength": _vm.maxLength,
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": _vm.focusEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d363357","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/common/myInput.vue
// module id = 345
// module chunks = 0